import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Form, Row, Pagination } from 'react-bootstrap';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Controller } from "react-hook-form";
import _ from "lodash";


const Paging = ({ control, getValues, setValue, watch, config }) => {

  const watchpageSize = watch("pageSize", false);
  const watchTotalCount = watch("totalCount", false);

  useEffect(() => {
    let newTotalPages = Math.ceil(_.toNumber(getValues("totalCount")) / _.toNumber(getValues("pageSize")));
    setValue("totalPages", newTotalPages);

    if (newTotalPages != 0 && _.toNumber(getValues("pageNumber")) > newTotalPages) {
      setValue("pageNumber", newTotalPages);
    }
  }, [watchpageSize, watchTotalCount]);
  useEffect(() => {
    setValue("pageNumber", 1);
    setValue("pageSize", 10);

  }, []);

  return (
    <>
      <Row className="py-4 mb-5 table-footer">
        <Col xs={12} sm={6} md={3} lg={6} xl={2} className=" my-auto">
          {_.toNumber(getValues("pageSize")) * (_.toNumber(getValues("pageNumber")) - 1) + 1 ?? 0}
                    -
                    {" "}
          {_.toNumber(getValues("pageNumber")) == _.toNumber(getValues("totalPages")) ? _.toNumber(getValues("totalCount")) : _.toNumber(getValues("pageSize")) * _.toNumber(getValues("pageNumber")) ?? 0} {" "}
                    از  {getValues("totalCount") ?? 0} رکورد </Col>
        <Col xs={12} sm={6} md={5} lg={6} xl={4} className="text-sm-right my-auto text-xl-left">
          تعداد صفحات : <strong>{_.toString(getValues("totalPages"))}</strong> |
                    بروبه صفحه
                    <Controller
            name="pageNumber"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Form.Control
                size="sm"
                className="d-inline-block "
                style={{ width: '60px' }}
                type="text"
                value={value || ""}
                onChange={event => {
                  if (event.target.value > getValues("totalPages")) {
                    return;
                  }
                  else {
                    onChange(event);
                    (document.getElementById('submitButton')).click();

                  }
                }} />
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={6} xl={3} className="text-md-right text-lg-left mt-3 mt-xl-0 my-auto">
          <span className="text-small mt-4 mt-sm-0">  نمایش هر صفحه: </span>
          <Controller
            name="pageSize"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Form.Control
                as="select"
                size="sm"
                className="d-inline-block"
                style={{ width: '60px' }}
                value={value}
                onChange={(event) => {
                  onChange(event);
                  (document.getElementById('submitButton')).click();
                }
                }
              >
                {config.length_menu.map((item, index) =>
                  <option key={index} value={item}>{item}</option>
                )}
              </Form.Control>

            )}
          />

        </Col>

        <Col xs={12} sm={6} md={12} lg={6} xl={3} className="text-sm-right pl-md-0">
          <ButtonGroup className="ml-sm-3 mt-3 mt-xl-0 d-flex justify-content-between">

            <Button variant="secondary" size="sm"
              onClick={() => {
                setValue("pageNumber", 1);
                (document.getElementById('submitButton')).click();

              }}
              disabled={_.toNumber(getValues("pageNumber")) === 1 ?? true}
            >
              <LastPage />
            </Button>

            {/* last page */}
            <Button variant="secondary"
              onClick={() => {
                setValue("pageNumber", _.toNumber(getValues("pageNumber")) - 1);
                (document.getElementById('submitButton')).click();


              }}
              disabled={_.toNumber(getValues("pageNumber")) === 1 ?? true}
            >
              <ChevronRight />
            </Button>

            {/* current page */}
            <Button variant="dark" className="disable" disabled={true}>
              {getValues("pageNumber")}
            </Button>

            {/* next page */}
            <Button variant="secondary"
              onClick={(e) => {
                setValue("pageNumber", _.toNumber(getValues("pageNumber")) + 1);
                (document.getElementById('submitButton')).click();


              }}
              disabled={_.toNumber(getValues("pageNumber")) === _.toNumber(getValues("totalPages"))}>
              <ChevronLeft />
            </Button>

            {/* last page */}
            <Button variant="secondary"
              onClick={(e) => {
                setValue("pageNumber", getValues("totalPages"));
                (document.getElementById('submitButton')).click();

              }}
              disabled={_.toNumber(getValues("pageNumber")) === _.toNumber(getValues("totalPages"))}
            >
              <FirstPage />
            </Button>
          </ButtonGroup>

        </Col>
        <input id="submitButton" className="d-none" type="submit" />

      </Row>
    </>
  );
};

export default Paging;


